import { Auth } from "./Auth";
export function createAuthInstance(configuration, rest) {
    return new Auth(configuration, rest);
}
